import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export interface IntegrationItem {
  _id: string;
  platformName: string;
  description: string;
  iconUrl: string;
  fieldDependencies?: any;
  isConnected: boolean;
}

export interface IntegrationCategory {
  name: string;
  items: IntegrationItem[];
  count: number;
}

@Injectable({
  providedIn: 'root'
})
export class IntegrationStateService {
  private selectedCategorySource = new BehaviorSubject<string>('Project Management');
  selectedCategory$ = this.selectedCategorySource.asObservable();

  private selectedIntegrationSource = new BehaviorSubject<string | null>(null);
  selectedIntegration$ = this.selectedIntegrationSource.asObservable();

  private searchQuerySource = new BehaviorSubject<string>('');
  searchQuery$ = this.searchQuerySource.asObservable();

  private refreshIntegrationsSource = new Subject<void>();
  refreshIntegrations$ = this.refreshIntegrationsSource.asObservable();

  constructor() {}

  setSelectedCategory(category: string) {
    this.selectedCategorySource.next(category);
  }

  setSelectedIntegration(integration: string | null) {
    this.selectedIntegrationSource.next(integration);
  }

  setSearchQuery(query: string) {
    this.searchQuerySource.next(query);
  }

  triggerRefresh() {
    this.refreshIntegrationsSource.next();
  }
}

